skrilla.controller('excludedUsersModalCtrl', async function ($scope, searchService, cacheService, modalService,
                                                             valuesToWordsService, sportService, userExclusionsService,
                                                             validationService, dateService, paginationService) {
    $scope.pageKey = "excludedUsers";
    $scope.sports = await sportService.getSports()
    $scope.person = cacheService.getObject($scope.pageKey);
    $scope.sportsExclusionsPageKey = "sportsExclusions"
    $scope.update = {indefinite: validationService.isEmpty($scope.person.effectiveUntil)};
    $scope.minDate = dateService.getTomorrowDate()
    $scope.validate = {}
    userExclusionsService.getExclusionTypes().then(function (exclusionTypes) {$scope.exclusionTypes = exclusionTypes});
    userExclusionsService.getRequesterTypes('person').then(function(requesters){$scope.requesters = requesters});

    $scope.save = function () {
        if (validate()) {
            modalService.confirm("Are you sure you'd like to update the register?", function () {
                if ($scope.person.exclusionType === 'SPORTS') {
                    $scope.person.requester = 'SPORTS_EXCLUSION_REQUESTERS'
                    $scope.person.reason = null
                    $scope.person.effectiveUntil = null
                } else {
                    if ($scope.update.indefinite === true) {
                        $scope.person.effectiveUntil = null;
                    }
                    if ($scope.person.reason === undefined) {
                        $scope.person.reason = null
                    }
                }
                $scope.person.id ? update() : create()
            });
        }
    }

    $scope.delete = function () {
        modalService.confirm("Are you sure you'd like delete this entry?", function () {
            searchService.deleteRequest("excludedPersonsRegister/" + $scope.person.id, "Register Successfully updated!").then(function (response) {
                modalService.dismissAll();
            });
        });
    }

    function create() {
        searchService.post("excludedPersonsRegister", $scope.person, "Register Successfully updated!").then(function (response) {
            $scope.person.id = response.data;
        })
        if ($scope.person.exclusionType !== 'SPORTS') {
            modalService.dismissAll();
        } else {
            cacheService.registerObject('sportsPerson', $scope.person)
            getSportsExclusionData()
        }
    }

    function update() {
        searchService.put("excludedPersonsRegister/" + $scope.person.id, $scope.person, "Register Successfully updated!").then(function() {
            modalService.dismissAll();
        });
    }
    function getLinkedUserSportsExclusions () {
        searchService.get("sportsExclusions/linkedUsers/" + $scope.person.id).then(function (response) {
            $scope.linkedUserSportsExclusions = response.data
            $scope.hasLinkedUser = validationService.isNotEmpty($scope.linkedUserSportsExclusions)
        })
    }
    if ($scope.person.id) getLinkedUserSportsExclusions()

    function getSportsExclusionData() {
        if ($scope.person.exclusionType === 'SPORTS') {
            searchService.get("sportsExclusions/person/" + $scope.person.id).then(function (response) {
                $scope.sportsExclusions = response.data
                cacheService.registerObject('sportsExclusions', $scope.sportsExclusions)
            })
        }
    }
    getSportsExclusionData()

    $scope.openSportsExclusionModal = function (exclusion) {
        exclusion = exclusion || {}
        cacheService.registerObject($scope.sportsExclusionsPageKey, {person: $scope.person, exclusion: exclusion});
        modalService.openModal("views/sportsExclusions/sportsExclusionsModal.html", true, 'lg', true, true, function(){
            cacheService.registerObject('sportsPerson', $scope.person)
        })
    }

    $scope.effectiveUntilColour = function (date) {
        return userExclusionsService.getEffectiveUntilColour(date)
    }

    var autocomplete;
    var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'short_name',
        postal_code: 'short_name'
    };

    function initAutocomplete() {
        // Create the autocomplete object, restricting the search to geographical
        // location types.
        autocomplete = new google.maps.places.Autocomplete(
            /** @type {!HTMLInputElement} */(document.getElementById('autocomplete')),
            {types: ['geocode']});

        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        autocomplete.addListener('place_changed', fillInAddress);
    }

    function fillInAddress() {
        // Get the place details from the autocomplete object.
        var place = autocomplete.getPlace();

        for (var component in componentForm) {
            document.getElementById(component).value = '';
            document.getElementById(component).disabled = false;
        }

        // Get each component of the address from the place details
        // and fill the corresponding field on the form.
        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            if (componentForm[addressType]) {
                $scope.person[valuesToWordsService.getUserFieldFromGoogleMapsKey(addressType)] = place.address_components[i][componentForm[addressType]];
                document.getElementById(addressType).value = place.address_components[i][componentForm[addressType]];
                $scope.$apply();
            }
        }
    }

    function validate(){
        let inputs = [
            validationService.buildFieldValidationObj("firstName", validationService.isNotEmpty($scope.person.firstName), "Please enter a first name"),
            validationService.buildFieldValidationObj("lastName", validationService.isNotEmpty($scope.person.lastName), "Please enter a last name"),
            validationService.buildFieldValidationObj("dateOfBirth", validationService.isNotEmpty($scope.person.dateOfBirth), "Please enter a DOB"),
            validationService.buildFieldValidationObj("exclusionType", validationService.isNotEmpty($scope.person.exclusionType), "Please select an exclusion type"),
        ]
        if ($scope.person.exclusionType === 'PRODUCT') {
            inputs.push(validationService.buildFieldValidationObj("requester", validationService.isNotEmpty($scope.person.requester), "Please select a requester"))
        }
        return validationService.validateForm(inputs, $scope.validate)
    }

    setTimeout(function () {
        initAutocomplete();
    }, 500);

    window.onload = function () {
        initAutocomplete();
    }

});
